import IntermediaryShareHoldersFormContent from './IntermediaryShareHoldersFormContent'

export default IntermediaryShareHoldersFormContent
